import { formatCurrency } from "@src/utilities/format-numbers"

export interface CartRelatedItemProps {
  cartPrice: number
  description?: string | null
  name: string
  retailPrice: number
  sku: string
  thumbnailUrl?: string | null
  onQuickAdd: (sku: string) => void
}
export default function CartRelatedItem({
  cartPrice,
  description,
  name,
  retailPrice,
  sku,
  thumbnailUrl,
  onQuickAdd,
}: CartRelatedItemProps) {
  return (
    <div className="mb-8" data-component="cart-related-item">
      <div className="flex items-start">
        <div
          className="block bg-center bg-cover w-20 before:content-[''] before:block before:pt-[100%] mr-3"
          style={{
            backgroundImage: `url(${
              thumbnailUrl ?? "/images/placeholder.jpeg"
            })`,
          }}
        />
        <div className="grow">
          <h5
            className="font-browser font-bold text-base"
            dangerouslySetInnerHTML={{ __html: name }}
          />
          <h6
            className="font-browser text-gray-600 text-xs"
            dangerouslySetInnerHTML={{
              __html: description ?? "",
            }}
          />
          <div className="font-browser font-medium mb-2">
            <div>
              {formatCurrency(cartPrice)}
              {cartPrice < retailPrice && (
                <span className="ml-1 font-normal text-xs text-orange line-through">
                  ({formatCurrency(retailPrice)})
                </span>
              )}
            </div>
          </div>
          <button
            className="outline-none bg-black px-4 py-2 font-medium text-xs text-browser text-white uppercase hover:bg-black-600 transition-colors"
            onClick={() => {
              onQuickAdd(sku)
            }}
          >
            Add to basket
          </button>
        </div>
        <div className="ml-4">
          <div className="hidden">
            <div>{formatCurrency(cartPrice)}</div>
            {cartPrice < retailPrice && (
              <div>{formatCurrency(retailPrice)}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
